import React from 'react';
import '../styles/Contact.css';

function Contact() {
  const handleChatClick = (e) => {
    e.preventDefault();
    
    // Try to trigger the official SuperOwl function if available
    if (window.triggerSuperOwlChat) {
      window.triggerSuperOwlChat();
      return;
    }
    
    // First try the widget button if it exists
    const superOwlWidgetButton = document.querySelector('.superowl-widget-button');
    if (superOwlWidgetButton) {
      superOwlWidgetButton.click();
      return;
    }
    
    // Try to make chat window visible if it exists
    const chatWindow = document.querySelector('.superowl-chat-window');
    if (chatWindow) {
      chatWindow.style.display = 'block';
      chatWindow.style.opacity = '1';
      chatWindow.style.visibility = 'visible';
      chatWindow.style.zIndex = '9999';
      return;
    }
    
    // Try common elements that might exist
    const elementIdsToTry = [
      '.superowl-widget-button', 
      '.superowl-chat-window',
      '.superowl-send'
    ];
    
    for (const selector of elementIdsToTry) {
      const element = document.querySelector(selector);
      if (element) {
        element.click();
        return;
      }
    }
    
    // If all else fails, dispatch a custom event
    document.dispatchEvent(new CustomEvent('superowl-open-chat'));
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-container">
          <div className="contact-content">
            <h3>Visit Our Studio</h3>
            <p>Join us for transformative Power Yoga and Vinyasa Flow sessions in the heart of Indiranagar, Bengaluru.</p>
            
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Location</h4>
                  <p>No 5/1, 1st Floor, Sweet Root<br />
                  Next to 80 feet road<br />
                  New Thippasandra, Indiranagar<br />
                  Bengaluru, Karnataka 560075</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div>
                  <h4>Class Timings</h4>
                  <p>Morning: 6:00 AM - 9:00 AM<br />
                  Evening: 6:00 PM - 8:00 PM<br />
                  Online sessions available 24/7</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">💬</div>
                <div>
                  <h4>Get in Touch</h4>
                  <p>Chat with TRO AI for instant guidance<br />
                  Book classes and get personalized sequences</p>
                  <button 
                    className="btn btn-outline"
                    onClick={handleChatClick}
                  >
                    Start TRO AI Chat
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="map-container">
            <div className="map-wrapper">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248849.90089765818!2d77.46612633984375!3d12.953945620572778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae167c1ae12d1b%3A0x5c8b1a2b8b2b8b2b!2sNew%20Thippasandra%2C%20Indiranagar%2C%20Bengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1677651234567!5m2!1sen!2sin"
                width="100%" 
                height="100%" 
                style={{ border: "0" }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Studio Location"
              />
              <div className="map-overlay">
                <a 
                  href="https://g.co/kgs/4mMwN3W" 
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="btn btn-primary"
                >
                  View on Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
